// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.up-grid-layout {
    width: 1300px;
    height: 1000vh;
    margin-left: -15px;  
    display: flex;
    flex-direction: column;
    background: black;
}

  .up-header-container {
    width: 1230px;
    height: 240px;
    max-height: 95%;
    max-width: 100%;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: lightgray;    
    overflow-y: auto;
    /* margin-top: 50px;
    margin-left: 100px; */    
  }

  .up-post-container {
    width: 1000%;
    height: 1000px;
    max-height: 95%;
    max-width: 100%;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: lightgray;    
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    /* margin-top: 50px;
    margin-left: 100px; */
  }

  .up-create-post-container {
    width: 1230px;
    height: 300px;
    overflow-y: auto;
    display: flex;
    flex-direction: row;
  }

  .up-description-input {
    height: 100%;
    width: 60%;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
    resize: none;
    overflow-y: auto;
    margin-left: 40px;
  }

  .up-submission-container {
    /* margin-top: 20px; */
    /* margin-left: 9px; */
    height: 100%;
    width: 30%;
    display: flex;
    flex-direction: column;
    /* max-width: 1000px;
    max-height: 1000vh; */
    padding: 15px;
    border-radius: 8px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
  }
  
  .up-media-section {
    /* margin-top: 60px;
    margin-bottom: 0px; */
    width: 30%;
    /* margin-left: 200px; */
    height: 30px;
    /* align-items: center; */
    gap: 10px;
    background: black;
    display: flex;
    flex-direction: column;
  }
  
  .up-upload-btn {
    padding: 8px 12px;
    width: 100px;
    height: 40px;
    align-items: center;
    margin-top: -5px;
    font-weight: bold;
    background: rgb(34, 31, 31);
    margin-left: 10px;
    color: white;
    cursor: pointer;
    border-radius: 10px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
    font-size: 16px;
  }
  
  .up-post-btn {
    padding: 8px 12px;
    width: 100px;
    height: 40px;
    align-items: center;
    font-weight: bold;
    font-family: puppins;
    background: rgb(34, 31, 31);
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 10px;
    margin-top: 10px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
    font-size: 16px;
  }

  .up-upload-btn:hover, .up-post-btn:hover {
    background: #0056b3;
  }
  
  .up-uploaded-media {
    margin-top: 10px;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
    font-size: 16px;
    color: white;
  }
  
  .up-media-preview {
    display: inline-block;
    padding: 5px;
    margin: 3px;
    background: black;
    color: white;
    border-radius: 4px;
  }

  .up-remove-btn {
    padding: 8px 12px;
    width: 100px;
    height: 40px;
    align-items: left;
    font-family: puppins;
    background: rgb(34, 31, 31);
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 10px;
    cursor: not-allowed; /* Show disabled cursor */
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; 
    font-size: 16px;
    opacity: 0.6;
    margin-top: 20px;
    font-weight: bold;
  }
  
  .up-remove-btn:not(:disabled) {
    background-color: darkgray;
    color: black;
    cursor: pointer;
    opacity: 1;
    font-weight: bold;
  }
  
.up-post-lower-segment {
  width: 100%;
  max-height: 1000vh;
  height: 400px;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
}

.up-post-header-segment {
  width: 100%;
  height: 50px;
  border-radius: 20px;
}

.up-post-feed-segment {
  width: 100%;
  height: 200px;
  border-radius: 20px;
}

.up-toggle-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 26px;
  margin-top: 5px;
}

.up-toggle-switch input {
  opacity: 0;
  width: 100;
  height: 0;
}

.up-toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: red;
  transition: 0.4s;
  border-radius: 30px;
}

.up-toggle-slider:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

.up-toggle-switch input:checked + .up-toggle-slider {
  background-color: green;
}

.up-toggle-switch input:checked + .up-toggle-slider:before {
  transform: translateX(24px);
}`, "",{"version":3,"sources":["webpack://./src/components/Pages/OverlayPage/Styles/Post.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;AACrB;;EAEE;IACE,aAAa;IACb,aAAa;IACb,eAAe;IACf,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB;yBACqB;EACvB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB;yBACqB;EACvB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IAEE,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,sBAAsB;IACtB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB;yBACqB;IACrB,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,gBAAgB;EAClB;;EAEA;IACE;yBACqB;IACrB,UAAU;IACV,wBAAwB;IACxB,YAAY;IAEZ,yBAAyB;IACzB,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mJAAmJ;IACnJ,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IAEpB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,mJAAmJ;IACnJ,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mJAAmJ;IACnJ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;IAEpB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,mBAAmB,EAAE,yBAAyB;IAC9C,mJAAmJ;IACnJ,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;IACZ,eAAe;IACf,UAAU;IACV,iBAAiB;EACnB;;AAEF;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".up-grid-layout {\n    width: 1300px;\n    height: 1000vh;\n    margin-left: -15px;  \n    display: flex;\n    flex-direction: column;\n    background: black;\n}\n\n  .up-header-container {\n    width: 1230px;\n    height: 240px;\n    max-height: 95%;\n    max-width: 100%;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: lightgray;    \n    overflow-y: auto;\n    /* margin-top: 50px;\n    margin-left: 100px; */    \n  }\n\n  .up-post-container {\n    width: 1000%;\n    height: 1000px;\n    max-height: 95%;\n    max-width: 100%;\n    padding: 15px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background: lightgray;    \n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    /* margin-top: 50px;\n    margin-left: 100px; */\n  }\n\n  .up-create-post-container {\n    width: 1230px;\n    height: 300px;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: row;\n  }\n\n  .up-description-input {\n    margin-left: 10px;\n    height: 100%;\n    width: 60%;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    resize: none;\n    overflow-y: auto;\n    margin-left: 40px;\n  }\n\n  .up-submission-container {\n    /* margin-top: 20px; */\n    /* margin-left: 9px; */\n    height: 100%;\n    width: 30%;\n    display: flex;\n    flex-direction: column;\n    /* max-width: 1000px;\n    max-height: 1000vh; */\n    padding: 15px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n    overflow-y: auto;\n  }\n  \n  .up-media-section {\n    /* margin-top: 60px;\n    margin-bottom: 0px; */\n    width: 30%;\n    /* margin-left: 200px; */\n    height: 30px;\n    display: flex;\n    /* align-items: center; */\n    gap: 10px;\n    background: black;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .up-upload-btn {\n    padding: 8px 12px;\n    width: 100px;\n    height: 40px;\n    align-items: center;\n    margin-top: -5px;\n    font-weight: bold;\n    background: rgb(34, 31, 31);\n    margin-left: 10px;\n    color: white;\n    cursor: pointer;\n    border-radius: 10px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n    font-size: 16px;\n  }\n  \n  .up-post-btn {\n    padding: 8px 12px;\n    width: 100px;\n    height: 40px;\n    align-items: center;\n    font-weight: bold;\n    font-family: puppins;\n    font-size: 12px;\n    background: rgb(34, 31, 31);\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 10px;\n    margin-top: 10px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n    font-size: 16px;\n  }\n\n  .up-upload-btn:hover, .up-post-btn:hover {\n    background: #0056b3;\n  }\n  \n  .up-uploaded-media {\n    margin-top: 10px;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n    font-size: 16px;\n    color: white;\n  }\n  \n  .up-media-preview {\n    display: inline-block;\n    padding: 5px;\n    margin: 3px;\n    background: black;\n    color: white;\n    border-radius: 4px;\n  }\n\n  .up-remove-btn {\n    padding: 8px 12px;\n    width: 100px;\n    height: 40px;\n    align-items: left;\n    font-family: puppins;\n    font-size: 12px;\n    background: rgb(34, 31, 31);\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 10px;\n    cursor: not-allowed; /* Show disabled cursor */\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; \n    font-size: 16px;\n    opacity: 0.6;\n    margin-top: 20px;\n    font-weight: bold;\n  }\n  \n  .up-remove-btn:not(:disabled) {\n    background-color: darkgray;\n    color: black;\n    cursor: pointer;\n    opacity: 1;\n    font-weight: bold;\n  }\n  \n.up-post-lower-segment {\n  width: 100%;\n  max-height: 1000vh;\n  height: 400px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 20px;\n}\n\n.up-post-header-segment {\n  width: 100%;\n  height: 50px;\n  border-radius: 20px;\n}\n\n.up-post-feed-segment {\n  width: 100%;\n  height: 200px;\n  border-radius: 20px;\n}\n\n.up-toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 26px;\n  margin-top: 5px;\n}\n\n.up-toggle-switch input {\n  opacity: 0;\n  width: 100;\n  height: 0;\n}\n\n.up-toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: red;\n  transition: 0.4s;\n  border-radius: 30px;\n}\n\n.up-toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 4px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\n.up-toggle-switch input:checked + .up-toggle-slider {\n  background-color: green;\n}\n\n.up-toggle-switch input:checked + .up-toggle-slider:before {\n  transform: translateX(24px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
